import grey from './Grey';
import normal from './Normal';

export default {
   grey,
   normal
}